import Vue from 'vue'
import log from 'salvo-lite/log'
import CompatibilityCheckerUI from './CompatibilityChecker.vue'

export default class CompatibilityChecker {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._tags = (elem.getAttribute('data-compatibility-checker-model-tags') || '').split(',').map(s => s.trim())
        this._modelOptions = []

        const modelDataEl = elem.querySelector('[data-compatibility-checker-model-options]')
        if (modelDataEl) {
            this._modelOptions = JSON.parse(modelDataEl.innerHTML).models.filter(entry => !!entry.model)
        }

        this._modelTree = {}

        // eslint-disable-next-line camelcase
        for (let { model, model_label, year } of this._modelOptions) {
            if (!this._modelTree[model]) {
                this._modelTree[model] = {
                    value: model,
                    label: model_label,
                    years: []
                }
            }
            this._modelTree[model].years.push(year)
        }

        for (let model of Object.values(this._modelTree)) {
            // filter unique
            model.years = model.years.filter((v, i, s) => s.indexOf(v) === i)
        }

        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        this._vue = new Vue({
            el: this._elem,
            render: (e) => e(CompatibilityCheckerUI, {
                props: {
                    modelTree: this._modelTree,
                    compatibleTags: this._tags
                }
            })
        })
    }
}



// WEBPACK FOOTER //
// ./src/resources/scripts/components/garage/CompatibilityChecker.js